<template>
    <modal
        title="New group"
        :active="active"
        :dismissable="true"
        :loading="loading"
        @dismiss="dismiss"
    >

        <modal-body>

            <form @submit.prevent="create">
                <form-section label-width="100">

                    <control-group :valid="!$v.name.$error" title="Name">
                        <input
                            v-control
                            v-model.trim="name"
                            v-focus
                            @input="$v.name.$touch()"
                        />
                        <template v-if="$v.name.$error">
                            <control-error v-if="!$v.name.required">Choose a name for your group</control-error>
                            <control-error v-else-if="!$v.name.unique">This group name is already taken</control-error>
                        </template>

                        <checkbox label="Display this name to users" v-model="useNameAsReportName" />
                    </control-group>


                    <control-group v-if="!useNameAsReportName" :valid="!$v.reportName.$error" title="Display name">
                        <input
                            v-control
                            v-model.trim="reportName"
                            @input="$v.reportName.$touch()"
                        />
                        <template v-if="$v.reportName.$error">
                            <control-error v-if="!$v.reportName.required">Choose a display name for your group</control-error>
                        </template>
                    </control-group>

                </form-section>
            </form>

        </modal-body>

        <modal-actions>
            <btn primary @click="create">Create</btn>
            <btn link @click="cancel">Cancel</btn>
        </modal-actions>

    </modal>
</template>


<script>
    import _ from 'lodash';
    import { required, requiredIf } from 'validators';
    import { AsyncMixin, FormValidationMixin, ModalMixin } from 'pdk/mixins';
    import { groups } from '@/services';


    export default {
        name: 'create-group-modal',
        mixins: [AsyncMixin, FormValidationMixin, ModalMixin],
        data() {
            return {
                name: null,
                useNameAsReportName: true,
                reportName: null,
                unavailableNames: []
            };
        },
        validations: {
			name: {
                required,
                unique: (value, vm) => {
                    return !_.includes(vm.unavailableNames, value);
                }
            },
            reportName: {
                required: requiredIf((vm) => {
                    return !vm.useNameAsReportName;
                })
            }
		},
        methods: {
            onClose() {
                this.name = null;
                this.useNameAsReportName = true;
                this.reportName = null;
                this.unavailableNames = [];

                this.resetValidation();
            },
            create() {
                if (!this.validate()) return;

                const data = {
                    name: this.name,
                    reportName: this.useNameAsReportName ? this.name : this.reportName
                };

                this.async(groups.createGroup(data))
                    .then((group) => {
                        this.$emit('create', {
                            group: {
                                locationGroupID: group.locationGroupID,
                                ...data
                            }
                        });
                        this.close();
                    })
                    .catch((error) => {
                        const status = error.response.data;
                        switch (status) {
                            case "LocationGroupNameAlreadyExists":
                                this.unavailableNames.push(this.name);
                                break;
                            default:
                                break;
                        }
                    });
            }
        }
    };
</script>
